<template>

  <feedback-modal class="target-modal" @dismiss="emitDismiss" ref="feedbackModal">

    <div class="target-modal__message">{{ message }}</div>

  </feedback-modal>

</template>

<script>

import FeedbackModal from './FeedbackModal'
import ActionButton from '@/components/common/actionButton'

export default {
  components: {
    'feedback-modal': FeedbackModal, ActionButton
  },
  props: {
    message: {
      type: String,
      default: 'Error handling your submission.'
    }
  },
  methods: {
    open () {
      this.$refs.feedbackModal.open()
    },
    close () {
      this.$refs.feedbackModal.close()
    },
    emitDismiss () {
      console.log('errorModalDismiss')
      this.$emit('dismiss')
    }
  }
}

</script>

<style lang="scss">

.target-modal {

  &__message {
    text-align: center;
    font-weight: bold;
    font-size: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// ErrorModal.vue?7de242de